export const BYTES_TO_MEGA_BYTE = 1048576;
export const FILE_IMAGES = {
  png: 'image', jpeg: 'image', svg: 'image', bmp: 'image', doc: 'word', docx: 'word', txt: 'word', mp4: 'video', avi: 'video', mpg: 'video', mpeg: 'video', mkv: 'video', ppt: 'powerpoint', pptx: 'powerpoint', pps: 'powerpoint', xlsx: 'excel', xlsm: 'excel', xls: 'excel', pdf: 'pdf', default: 'file',
};
